import { Injectable } from '@angular/core';
import { BackendService } from "../backend/backend.service";
import { AuthenticationService } from "../authentication/authentication.service";
import { CoreService } from "../core/core.service";
@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  private langpath = "/languages";
  private path = "/survey"

  constructor(

    private backendService: BackendService,
    private auth: AuthenticationService,
    private core: CoreService

  ) { }

  getLanguages() {
    return this.backendService.get(this.langpath);
  }

  getExams(){
    return this.backendService.get(this.path);
}

  saveSurvey(survey) {
    return this.backendService.post(this.path, survey);
  }

  getSurveyById(surveyId) {
    return this.backendService.get(this.path + "/" +surveyId);
  }

  deleteSurveyById(surveyId) {
    return this.backendService.post(
      this.path  + "/" + surveyId + "/delete",
      {}
    );
  }

  searchSurvey(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);

  }

 
}
